import { render, staticRenderFns } from "./post-back.vue?vue&type=template&id=12d1dc86&scoped=true&"
import script from "./post-back.vue?vue&type=script&lang=js&"
export * from "./post-back.vue?vue&type=script&lang=js&"
import style0 from "./post-back.vue?vue&type=style&index=0&id=12d1dc86&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d1dc86",
  null
  
)

export default component.exports